<template>
    <KPI></KPI>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const KPI = defineAsyncComponent(() =>
    import("../../components/Management/KPI/KPI.vue")
);
export default {
    name: "Management_KPI", //The name you are in should not equal the name of the component you are importing.
    components: { KPI, AuthLayout },
};
</script>